export const MIGRATION_KEY_SPLIT = '__' as const;
export type TMigrationKeySplit = typeof MIGRATION_KEY_SPLIT;
export type TMigrationKey = `${string}${TMigrationKeySplit}${string}`;
